export const offerLanguages = {
  en: {
    // Privacy notice
    privacyNotice: "Do not share with anyone besides your inner circle.",
    invoiceNotice: "Please keep this invoice for your records. Payment is due within the specified payment term. This document must be retained for at least 10 years in accordance with tax regulations.",
    
    // Customer info labels
    customerLogoPlaceholder: "Customer logo",
    forLabel: "For:",
    createdOnLabel: "Created on:",
    validUntilLabel: "Valid until:",
    paymentDueLabel: "Payment due:",
    deliveryTimeLabel: "Delivery time:",
    referenceLabel: "Reference:",
    offerNumberLabel: "Offer Number:",
    
    // Services section
    includedServicesHeading: "Included Services",
    noServicesSelected: "No services selected",
    serviceColumnHeader: "Service",
    priceColumnHeader: "Price",
    discountColumnHeader: "%",
    finalColumnHeader: "Final",
    monthlyBadge: "Monthly",
    perAppointmentBadge: "Per Appointment",

    // Payment type labels (toggle in service editor)
    paymentTypeOneTime: "One Time",
    paymentTypeRecurring: "Recurring",
    paymentTypePerAppointment: "Per Appointment",

    // Price suffixes
    pricePerAppointmentSuffix: "/appt.",
    priceMonthlySuffix: "/mo",

    // Summary section
    totalValueOfServices: "Total value of services:",
    serviceDiscounts: "Service discounts:",
    globalDiscount: "Global discount:",
    subtotal: "Subtotal:",
    taxes: "Taxes:",
    reverseCharge: "Reverse Charge – Tax liability transfer",
    reverseChargeInfo: "According to the reverse charge procedure, the tax liability is transferred to the recipient of the service. As a business operating cross-border, I provide services to you as a business customer. The tax obligation and VAT reporting lies with the recipient according to the applicable VAT regulations in your jurisdiction (e.g. § 13b UStG in Germany, § 19 UStG in Austria).",
    offerPrice: "Total price:",
    oneTimePayment: "One-time payment:",
    monthlyPayment: "Monthly payment:",
    perAppointmentPayment: "Per appointment:",
    
    // Payment button
    defaultPaymentButtonText: "Pay with Stripe",

    // Terms section
    termsHeading: "Terms & Conditions",

    // Signature / acceptance section
    signatureHeading: "Acceptance of Offer",
    signatureIntro: "By signing below, the parties hereby accept the above offer including the terms and conditions.",
    signaturePlaceDate: "Place, Date",
    signatureCustomerLabel: "Signature Customer",
    signatureProviderLabel: "Signature Provider",
    signatureNameRoleHint: "Name, Function",

    // Footer section
    offerCreatedBy: "Offer created for you by",
    questionsContact: "Contact us:",
    defaultContact: "contact@yourcompany.io",
    defaultCompanySlogan: "Your expert platform for digital marketing",
    bankingDetails: "Banking Details",
    contactHeader: "Contact",
    defaultWebsite: "www.bonusclub.io",
    defaultEmail: "info@bonusclub.io",
    
    // Loading and error states
    loadingText: "Loading offer preview...",
    noOfferAvailable: "No offer preview available"
  },
  
  de: {
    // Privacy notice
    privacyNotice: "Vertraulich - nur für den internen Gebrauch bestimmt.",
    invoiceNotice: "Bitte bewahren Sie diese Rechnung zu Ihren Unterlagen auf. Zahlung erfolgt gemäß vereinbartem Zahlungsziel. Diese Rechnung ist gemäß steuerrechtlicher Vorgaben mindestens 10 Jahre aufbewahrungspflichtig.",
    
    // Customer info labels
    customerLogoPlaceholder: "Firmenlogo",
    forLabel: "Kunde:",
    createdOnLabel: "Erstellt:",
    validUntilLabel: "Gültig bis:",
    paymentDueLabel: "Zahlungsziel:",
    deliveryTimeLabel: "Lieferzeit:",
    referenceLabel: "Referenz:",
    offerNumberLabel: "Angebotsnummer:",
    
    // Services section
    includedServicesHeading: "Leistungsumfang",
    noServicesSelected: "Keine Leistungen ausgewählt",
    serviceColumnHeader: "Leistung",
    priceColumnHeader: "Preis",
    discountColumnHeader: "%",
    finalColumnHeader: "Endpreis",
    monthlyBadge: "Monatlich",
    perAppointmentBadge: "Pro Termin",

    // Payment type labels (toggle in service editor)
    paymentTypeOneTime: "Einmalig",
    paymentTypeRecurring: "Monatlich",
    paymentTypePerAppointment: "Pro Termin",

    // Price suffixes
    pricePerAppointmentSuffix: "/Termin",
    priceMonthlySuffix: "/Mt.",

    // Summary section
    totalValueOfServices: "Gesamtwert:",
    serviceDiscounts: "Rabatte:",
    globalDiscount: "Gesamtrabatt:",
    subtotal: "Zwischensumme:",
    taxes: "MwSt.:",
    reverseCharge: "Reverse Charge – Steuerschuldübergang",
    reverseChargeInfo: "Gemäß Reverse-Charge-Verfahren geht die Steuerschuld auf den Leistungsempfänger über. Als grenzüberschreitend tätiger Unternehmer erbringe ich Leistungen an Sie als Unternehmer. Die Steuerschuld und Umsatzsteuer-Meldepflicht liegt beim Leistungsempfänger gemäß den gültigen Umsatzsteuerbestimmungen in Ihrem Land (z.B. § 13b UStG in Deutschland, § 19 UStG in Österreich).",
    offerPrice: "Gesamtbetrag:",
    oneTimePayment: "Einmalzahlung:",
    monthlyPayment: "Monatsrate:",
    perAppointmentPayment: "Pro Termin:",
    
    // Payment button
    defaultPaymentButtonText: "Jetzt bezahlen",

    // Terms section
    termsHeading: "Angebotsbedingungen",

    // Signature / acceptance section
    signatureHeading: "Annahme des Angebots",
    signatureIntro: "Hiermit nehmen die Vertragsparteien das obenstehende Angebot einschließlich der darin enthaltenen Bedingungen an.",
    signaturePlaceDate: "Ort, Datum",
    signatureCustomerLabel: "Unterschrift Auftraggeber",
    signatureProviderLabel: "Unterschrift Auftragnehmer",
    signatureNameRoleHint: "Name, Funktion",

    // Footer section
    offerCreatedBy: "Ihr Ansprechpartner:",
    questionsContact: "Kontaktieren Sie uns:",
    defaultContact: "info@bonusclub.io",
    defaultCompanySlogan: "BonusClub LLC | B2B Outreach & Lead Generation",
    bankingDetails: "Bankdaten",
    contactHeader: "Kontakt",
    defaultWebsite: "www.bonusclub.io",
    defaultEmail: "info@bonusclub.io",
    
    // Loading and error states
    loadingText: "Angebot wird geladen...",
    noOfferAvailable: "Angebot nicht verfügbar"
  }
};

// Helper function to get text by language
export const getOfferText = (language, key) => {
  return offerLanguages[language]?.[key] || offerLanguages.en[key] || key;
};

/**
 * Payment type values: 'oneTime' | 'recurring' | 'perAppointment'
 *
 * Backwards compatibility:
 * - If `paymentType` is set on the service/override, it wins.
 * - Else fall back to legacy `isRecurring` boolean.
 */
export const PAYMENT_TYPES = {
  ONE_TIME: 'oneTime',
  RECURRING: 'recurring',
  PER_APPOINTMENT: 'perAppointment'
};

export const getPaymentType = (service) => {
  if (!service) return PAYMENT_TYPES.ONE_TIME;
  if (service.paymentType) return service.paymentType;
  if (service.isRecurring) return PAYMENT_TYPES.RECURRING;
  return PAYMENT_TYPES.ONE_TIME;
};

// Used when migrating new paymentType back to the legacy isRecurring flag
// so that older read paths keep working.
export const isRecurringFromPaymentType = (paymentType) =>
  paymentType === PAYMENT_TYPES.RECURRING;

// Per-service price suffix shown next to a single line item's price.
export const getPriceSuffix = (paymentType, language) => {
  if (paymentType === PAYMENT_TYPES.RECURRING) {
    return getOfferText(language, 'priceMonthlySuffix');
  }
  if (paymentType === PAYMENT_TYPES.PER_APPOINTMENT) {
    return getOfferText(language, 'pricePerAppointmentSuffix');
  }
  return '';
};

// Date formatting by language
export const formatDateByLanguage = (timestamp, language) => {
  const date = new Date(timestamp);
  
  if (language === 'de') {
    return date.toLocaleDateString("de-DE", {
      day: "2-digit",
      month: "2-digit", 
      year: "numeric"
    });
  } else {
    return date.toLocaleDateString("en-US", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric"
    });
  }
};

// Price formatting by language
export const formatPriceByLanguage = (price, language) => {
  if (language === 'de') {
    return new Intl.NumberFormat("de-DE", {
      style: "currency",
      currency: "EUR"
    }).format(price);
  } else {
    return new Intl.NumberFormat("en-US", {
      style: "currency", 
      currency: "EUR"
    }).format(price);
  }
}; 